import { AppConfig } from 'shared/types';

export const getAppConfig = async (baseUrl: string) => {
  const response = await fetch(`${baseUrl}/api/config`);
  const config: AppConfig = await response.json();
  return { ...config, googleTagId: 'G-L431TJ8NQD' };
};
